import { Button, Col, Progress, Row, Form } from "antd";
import { PlayCircleFilled } from "@ant-design/icons";
import React, { useState } from "react";
import { useEffect } from "react";
import { withRouter, Link, Redirect } from "react-router-dom";
import useAuth from "../../../hooks/useAuth";
import { ESTATUS_CON_OBSERVACIONES, ESTATUS_OBSERVACIONES_ATENDIDAS, ESTATUS_VALIDADO, ID_PUESTO_ORG_ELECTORAL, ID_PUESTO_PRESIDENTE, MSN_GUARDAR, OBS_SOLICITA_DOC, OBS_VALIDA_CONT_ORG, OBS_VALIDA_DATOS_ORG, OBS_VALIDA_DOC, OBS_VALIDA_DOM_ORG, OBS_VALIDA_REPRE_ORG } from "../../../utils/constanst";
import { getOrganitationViewUpd } from "../../../api/organitation";
import { Ast } from "../../../utils/Validations/functions";
import SolicitaDocOrg from "../../../components/Admin/ValOrganizacion/StepsOrg/SolicitaDocOrg";
import ValidaDocOrg from "../../../components/Admin/ValOrganizacion/StepsOrg/ValidaDocOrg";
import ValidaDatosOrg from "../../../components/Admin/ValOrganizacion/StepsOrg/ValidaDatosOrg";
import ValidaRepreOrg from "../../../components/Admin/ValOrganizacion/StepsOrg/ValidaRepreOrg";
import ValidaDomOrg from "../../../components/Admin/ValOrganizacion/StepsOrg/ValidaDomOrg";
import ValidaContOrg from "../../../components/Admin/ValOrganizacion/StepsOrg/ValidaContOrg";
import { modalConfirma } from "../../../utils/ValOrganizacion/functionsValOrg";
import { getFuncionarios } from "../../../api/courses";
import { getObservacionesOrg } from "../../../api/validacionOrg";

function Validacion(props) {

    const { history, setLoader, proceso: { proceso } } = props;
    const { idOrg } = props.location; //Se obtien los valores por la url
    const { user: { user } } = useAuth();
    const [form] = Form.useForm();
    const [current, setCurrent] = useState({ steps: 0, percent: 0 }); //Para controlar la barra de progreso
    const percent = 25; //Porcentaje de avance por cada pantalla de validación
    const [organizacion, setOrganizacion] = useState({});
    const [observaciones, setObservaciones] = useState({}); //Para controlar las preguntas de revisión
    const [disabled, setDisabled] = useState({}); //Para bloquear las preguntas de cada pantalla   

    //console.log('----Validación Organización-----');

    useEffect(() => {

        //console.log('idOrg::::',idOrg);

        window.scrollTo(0, 0); // para posicionar el scroll al inicio

        if ( idOrg ) {

            setLoader({ loading: true, message: MSN_GUARDAR });

            //Inicializamos el 'validaDoc' para controlar el inicio del botón 'Siguiente' en el step 1 
            setObservaciones({...observaciones, validaDoc: null});

            getOrganitationViewUpd(true, proceso.idProcesoElectoral, 0, idOrg).then((res) => {

                console.log('res.data.voOrganizacion-->', res.data.voOrganizacion);

                setOrganizacion(res.data.voOrganizacion);

                res.data.voOrganizacion.urlSolicitudVista !== null ? setCurrent({...current, steps: 1}) : setCurrent({...current, steps: 0});

                //Manejo de observaciones habilitadas o deshabilitadas con base al idEstatus de la organización
                switch(res.data.voOrganizacion.idEstatus) {

                    case ESTATUS_OBSERVACIONES_ATENDIDAS:

                        console.log('<-- 2 -->');

                        //Se bloquean las preguntas
                        setDisabled({
                            solicitaDoc: true, 
                            validaDoc: true, 
                            validaDatosOrg: true,
                            validaRepreOrg: true, 
                            validaDomOrg: true, 
                            validaContOrg: true
                        });

                        let observacionDoc;
                        let disabledDatos, disabledRepre, disabledDom, disabledCont;

                        getObservacionesOrg(idOrg, proceso.idProcesoElectoral).then((resp) => {

                            resp.data.observacionesOrg.forEach((obs) => {

                                /**
                                 * 9-Solicita documento organización. Par la sección de Soporte_Documental
                                 * 10-No valida documento organización. Para la sección de Soporte_Documental
                                 */
                                if(obs.idObservacion === OBS_SOLICITA_DOC || obs.idObservacion === OBS_VALIDA_DOC) {
                                    observacionDoc = true;
                                }

                                /**
                                 * 11-No valida datos generales organización. Para la sección de Datos_Generales
                                 */
                                if(obs.idObservacion === OBS_VALIDA_DATOS_ORG && obs.estatus === 2) {
                                    disabledDatos = false;
                                    observacionDoc = false;
                                }

                                /**
                                 * 12-No valida representante organización. Para la sección de Representante
                                 */
                                if(obs.idObservacion === OBS_VALIDA_REPRE_ORG && obs.estatus === 2) {
                                    disabledRepre = false;
                                    observacionDoc = false;

                                }

                                /**
                                 * 13-No valida domicilio organización.	Para la sección de Domicilio
                                 */
                                if(obs.idObservacion === OBS_VALIDA_DOM_ORG && obs.estatus === 2) {
                                    disabledDom = false;
                                    observacionDoc = false;
                                }

                                /**
                                 * 14-No valida contacto organización. Para la sección de Datos_Contacto
                                 */
                                if(obs.idObservacion === OBS_VALIDA_CONT_ORG && obs.estatus === 2) {
                                    disabledCont = false;
                                    observacionDoc = false;
                                }
                            });

                            //console.log('observacionDoc::',observacionDoc);
                           

                            if ( observacionDoc ) {
                                console.log('En el IF');
                                setDisabled({
                                    solicitaDoc: false, 
                                    validaDoc: false, 
                                    validaDatosOrg: false,
                                    validaRepreOrg: false, 
                                    validaDomOrg: false, 
                                    validaContOrg: false
                                });

                            } else {
                                console.log('En el ELSE');

                                setDisabled(dis => ({ ...dis,
                                    validaDatosOrg: disabledDatos !== undefined ? disabledDatos : true,
                                    validaRepreOrg: disabledRepre !== undefined ? disabledRepre : true,
                                    validaDomOrg: disabledDom !== undefined ? disabledDom : true,
                                    validaContOrg: disabledCont !== undefined ? disabledCont : true
                                }));

                                //Ponemos como validadas las preguntas que no tiene observaciones
                                setObservaciones({
                                    solicitaDoc: false, 
                                    validaDoc: true,
                                    validaDatosOrg: disabledDatos === undefined ? true : undefined,
                                    validaRepreOrg: disabledRepre === undefined ? true : undefined,
                                    validaDomOrg: disabledDom === undefined ? true : undefined,
                                    validaContOrg: disabledCont === undefined ? true : undefined
                                });                                
                            }
                        }).catch((error) => {
                            console.log(error);
                        });
                        break;

                    case ESTATUS_CON_OBSERVACIONES:

                        console.log('<-- 3 -->');

                        //Se bloquean las preguntas
                        setDisabled({
                            solicitaDoc: true, 
                            validaDoc: true, 
                            validaDatosOrg: true,
                            validaRepreOrg: true, 
                            validaDomOrg: true, 
                            validaContOrg: true
                        });

                        let solicitaDoc, validaDoc, validaDocObs, validaDatosOrg, validaDatosOrgObs,
                            validaRepreOrg, validaRepreOrgObs, validaDomOrg, validaDomOrgObs, validaContOrg, validaContOrgObs;

                        getObservacionesOrg(idOrg, proceso.idProcesoElectoral).then((resp) => {

                            console.log('3- observacionesOrg -->', resp.data.observacionesOrg);

                            resp.data.observacionesOrg.forEach((obs) => {

                                console.log('3- estatus', obs.estatus);

                                if(obs.idObservacion === OBS_SOLICITA_DOC) {
                                    if(obs.estatus === 1) {
                                        solicitaDoc = true;
                                    }
                                }
                                if(obs.idObservacion === OBS_VALIDA_DOC) {
                                    if(obs.estatus === 1) {
                                        validaDoc = false;
                                        validaDocObs = obs.observaciones;
                                    }
                                }
                                if(obs.idObservacion === OBS_VALIDA_DATOS_ORG) {
                                    if(obs.estatus === 1) {
                                        validaDatosOrg = false;
                                        validaDatosOrgObs = obs.observaciones;
                                    }
                                }
                                if(obs.idObservacion === OBS_VALIDA_REPRE_ORG) {
                                    if(obs.estatus === 1) {
                                        validaRepreOrg = false;
                                        validaRepreOrgObs = obs.observaciones;
                                    }
                                }
                                if(obs.idObservacion === OBS_VALIDA_DOM_ORG) {     
                                    if(obs.estatus === 1) {
                                        validaDomOrg = false;
                                        validaDomOrgObs = obs.observaciones;
                                    }                               
                                }
                                if( obs.idObservacion === OBS_VALIDA_CONT_ORG ) {
                                    if(obs.estatus === 1) {
                                        validaContOrg = false;
                                        validaContOrgObs = obs.observaciones;
                                    }
                                }
                            });

                            setObservaciones({
                                solicitaDoc: solicitaDoc !== undefined ? solicitaDoc : false,
                                validaDoc: validaDoc !== undefined ? validaDoc : true, validaDocObs: validaDocObs,
                                validaDatosOrg: validaDatosOrg !== undefined ? validaDatosOrg : true,
                                validaDatosOrgObs: validaDatosOrgObs,
                                validaRepreOrg: validaRepreOrg !== undefined ? validaRepreOrg : true,
                                validaRepreOrgObs: validaRepreOrgObs,
                                validaDomOrg: validaDomOrg !== undefined ? validaDomOrg : true,
                                validaDomOrgObs: validaDomOrgObs,
                                validaContOrg: validaContOrg !== undefined ? validaContOrg : true,
                                validaContOrgObs: validaContOrgObs
                            });
                        });
                        break;

                    case ESTATUS_VALIDADO:

                        console.log('<-- 4 -->');    

                        //Se bloquean las preguntas
                        setDisabled({
                            solicitaDoc: true, 
                            validaDoc: true, 
                            validaDatosOrg: true, 
                            validaRepreOrg: true, 
                            validaDomOrg: true, 
                            validaContOrg: true
                        });

                        //Observaciones validadas
                        setObservaciones({
                            solicitaDoc: false, 
                            validaDoc: true, 
                            validaDatosOrg: true, 
                            validaRepreOrg: true, 
                            validaDomOrg: true, 
                            validaContOrg: true
                        });
                        
                        form.setFieldsValue({
                            validaDoc:true,
                        });
                        
                        break;

                    default:
                        console.log('<-- default -->');

                        form.setFieldsValue({
                            solicitaDoc: null, 
                            validaDoc: null, 
                            validaDatosOrg: null,
                            validaRepreOrg: null, 
                            validaDomOrg: null, 
                            validaContOrg: null
                        });
                        break;
                }

                setLoader({ loading: false, message: "" });              

            }).catch((error) => {
                console.log(error);
                setLoader({ loading: false, message: "" });
            });

        }        

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [idOrg]);

    //Redirecciona a la pantalla principal del módulo en caso de que no exista el id de la organización
    if ( !idOrg ) {
        return <Redirect to={"/admin/validacionOrg"} />;
    }

    //Función que va almacenando las respuestas de cada pregunta
    const onChangeRadio = (input) => (event) => {

        setObservaciones({...observaciones, [input]: event.target.value});

        if ( (input === "solicitaDoc" && event.target.value) || 
             (input === "validaDoc" && !event.target.value) || 
              input === "validaDocObs" ) {

            setCurrent({...current, percent: 100});

        } else if(current.steps === 0 || current.steps === 1) { //Se reinicia a 0 la barra de progreso en los steps 0 o 1
            setCurrent({...current, percent: 0});
        }
    };

    //Componentes de cada pantalla de revisión
    const steps = [
        {
            content: (
                <SolicitaDocOrg onChangeRadio={onChangeRadio}
                                observaciones={observaciones}
                                form={form}
                                disabled={disabled} />
            ),
        },
        {
            content: (
                <ValidaDocOrg organizacion={organizacion}
                              onChangeRadio={onChangeRadio}
                              form={form}
                              observacionesAux={observaciones}
                              disabled={disabled} />
            ),
        },
        {
            content: (
                <ValidaDatosOrg organizacion={organizacion}
                                onChangeRadio={onChangeRadio}
                                form={form}
                                observacionesAux={observaciones}
                                disabled={disabled} />
            ),
        },
        {
            content: (
                <ValidaRepreOrg organizacion={organizacion}
                                onChangeRadio={onChangeRadio}
                                form={form}
                                observacionesAux={observaciones}
                                disabled={disabled} />
            ),
        },
        {
            content: (
                <ValidaDomOrg organizacion={organizacion}
                              onChangeRadio={onChangeRadio}
                              form={form}
                              observacionesAux={observaciones}
                              disabled={disabled} />
            ),
        },
        {
            content: (
                <ValidaContOrg organizacion={organizacion}
                               onChangeRadio={onChangeRadio}
                               form={form}
                               observacionesAux={observaciones}
                               disabled={disabled} />
            ),
        },
    ];

    const anterior = () => {

        if(organizacion.urlSolicitudVista === null && current.steps === 2) {

            setCurrent({ //Cambia de pantalla y resta el porcentaje de la barra
                steps: current.steps - 2,
                percent: current.percent - percent,
            });

        } else {
            setCurrent({ //Cambia de pantalla y resta el porcentaje de la barra
                steps: current.steps - 1,
                percent: current.percent - percent,
            });
        }
    };

    const siguiente = () => {

        //Valida la información en los radios de cada pantalla
        form.validateFields().then((values) => {            

            if(current.steps === 0) {
                setCurrent({ //Cambia de pantalla y suma el porcentaje de la barra
                    steps: current.steps + 2,
                    percent: current.percent + percent,
                });
            } else {
                setCurrent({ //Cambia de pantalla y suma el porcentaje de la barra
                    steps: current.steps + 1,
                    percent: current.percent + percent,
                });
            }
        });
    };

    const enviaValidaObs = () => {

        form.validateFields().then((values) => {

            observaciones.idProceso = proceso.idProcesoElectoral;
            observaciones.idOrg = idOrg;
            observaciones.usuario = user.sub;

            if(current.steps === 0 || current.steps === 1) { //Mandan observaciones al documento
                observaciones.estatusValidacion = "error";
            } else {
                observaciones.estatusValidacion = validaObservaciones(observaciones) ? "valida" : "error";
            }

            var correosVocales = [];
            var correosVocalesStr;
            setLoader({ loading: true, message: MSN_GUARDAR }); //Se activa el loader

            getFuncionarios(proceso.idProcesoElectoral, 0, organizacion.idEstado, 0).then((res) => {

                if(res.data.integrantes !== undefined) {

                    for (let i = 0; i < res.data.integrantes.length; i++) {
                        if (res.data.integrantes[i].idPuesto === ID_PUESTO_PRESIDENTE || 
                            res.data.integrantes[i].idPuesto === ID_PUESTO_ORG_ELECTORAL) {
                            correosVocales.push(res.data.integrantes[i].correoElectronico);
                        }
                    }

                    correosVocalesStr = correosVocales.join(',');
                }

                setLoader({ loading: false, message: "" }); //Se desactiva el loader

                //observaciones.correosVocales="luiseder.velazquez@ine.mx,luiseder.velazquez@ine.mx"

                observaciones.correosVocales=correosVocalesStr;                

                console.log('values-->', values);
                console.log('observaciones-->', observaciones);

                modalConfirma(observaciones, setLoader, history);               

            }).catch((error) => {
                console.log("Error en el servicio web de funcionarios");
                console.log(error);
            });
        });
    };

    function validaObservaciones(obs) {

        const {validaDoc, validaDatosOrg, validaRepreOrg, validaDomOrg, validaContOrg} = obs;

        if(organizacion.urlSolicitudVista === null) {
            return validaDatosOrg && validaRepreOrg && validaDomOrg && validaContOrg;
        } else {
            return validaDoc && validaDatosOrg && validaRepreOrg && validaDomOrg && validaContOrg;
        }
    }

    return (
        <div>

            <Row>
                <Col span={24}>
                <Link to={"/admin/validacionOrg"} className="back">
                    <PlayCircleFilled rotate="180"/> Volver a
                    “Validación de solicitudes de organización”
                </Link>
                </Col>
            </Row>

            <Row style={{ marginTop:"20px"}}>
                <Col span={24}>
                    <h1>Revisar solicitud</h1>
                    <p>Los datos con ( <Ast /> ) son requeridos</p>
                </Col>
            </Row>

            <Row style={{ marginTop: 10}}>
                <Col span={6}>
                    Avance en la revisión
                </Col>
                <Col span={18}>

                    <Progress   percent={current.percent}
                                status="active" 
                                strokeColor="#e149a4" />

                </Col>
            </Row>

            <div style={{ marginTop: 20 }}>
                {steps[current.steps].content}
            </div>

            <Row style={{ marginTop: 20}}>
                <Col span={24} style={{ textAlign: "center"}}>
                    {current.steps > 1 && (
                        <Button onClick={anterior} type="default">
                            Anterior
                        </Button>
                    )}
                    {current.steps > 1 && current.steps < steps.length -1 && (
                        <Button type="primary" onClick={siguiente}>
                            Siguiente
                        </Button>
                    )}
                    {current.steps === 0 && !observaciones.solicitaDoc && (
                        <Button type="primary" onClick={siguiente}>
                            Siguiente
                        </Button>
                    )}
                    {current.steps === 0 && observaciones.solicitaDoc && 
                        organizacion.idEstatus !== ESTATUS_CON_OBSERVACIONES && 
                    (
                        <Button type="primary" style={{ width: "auto" }} onClick={enviaValidaObs}>
                            Enviar observaciones
                        </Button>
                    )}
                    {current.steps === 1 && (observaciones.validaDoc === null || observaciones.validaDoc) && (
                        <Button type="primary" onClick={siguiente}>
                            Siguiente
                        </Button>
                    )}
                    {current.steps === 1 && observaciones.validaDoc === false && 
                        organizacion.idEstatus !== ESTATUS_CON_OBSERVACIONES && 
                    (
                        <Button type="primary" style={{ width: "auto" }} onClick={enviaValidaObs}>
                            Enviar observaciones
                        </Button>
                    )}
                    {current.steps === steps.length - 1 && organizacion.idEstatus !== ESTATUS_CON_OBSERVACIONES &&
                        organizacion.idEstatus !== ESTATUS_VALIDADO &&
                    (
                        <Button type="primary" style={{ width: "auto" }} onClick={enviaValidaObs}>
                            {validaObservaciones(observaciones) ? "Validar organización" : "Enviar observaciones"}
                        </Button>
                    )}
                </Col>
            </Row>
        </div>
    );
}
const validacionForm = (Validacion)
export default withRouter(validacionForm);